import * as React from 'react';
import { ToneDto } from '../../../core/dto/tonedto';
import { BaseContext } from '../../../utils/basecontext';
import { AlertComponent } from '../../toolkit/alert/alertcomponent';
import { AlertType } from '../../toolkit/alert/alerttype';
import { GridComponent, GridComponentProps } from '../../toolkit/grid/gridcomponent';
import { SearchBoxComponent } from '../../toolkit/toolbarwithsearch/searchbox/searchboxcomponent';
import { SearchBoxCSSStyle } from '../../toolkit/toolbarwithsearch/searchbox/searchboxcss';
import { UIComponentHandler, UIComponentState, UIDataModel } from '../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../toolkit/uicomponentview';
import { PopUpWrapperComponent } from '../popup/popupwrappercomponent';
import { NameTuneListViewModelImpl } from './nametunecard/viewmodel/nametunelistviewmodel';
import { NameTunesComponentHandler, NameTunesComponentProps, NameTunesComponentState } from './nametunescomponent';
import { NameTunesCSSStyle } from './nametunescss';
import { NameTuneSearchCSSStyle } from './nametunesearchcss';
import { Strings } from '../../../utils/resources/strings';
import { LoaderComponent } from '../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../popup/loaderwrappercomponent';
import { NoResultComponent } from './noresult/noresultcomponent';
import './nametunes-style.css';

export class NameTunesViewImpl extends UIComponentViewImpl<UIDataModel>
{
 
    searchComponent: SearchBoxComponent;
    ref: GridComponent<GridComponentProps<ToneDto>, UIComponentState>;
    private searchCSSStyle :SearchBoxCSSStyle;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private popUpComponent: PopUpWrapperComponent;

    
    constructor(private featuredCategoryListViewModel: NameTuneListViewModelImpl,context:BaseContext, handler:UIComponentHandler)
    {
        super(context,handler);
        this.searchCSSStyle = new NameTuneSearchCSSStyle(context);
    }
    bindHandlers()
    {
        this.onSearchClick = this.onSearchClick.bind(this);
        this.clearData = this.clearData.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
    }

    draw(props: NameTunesComponentProps, state: NameTunesComponentState, cssStyle: NameTunesCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        console.log("------searchKey: " + props.searchKey);

        // this.featuredCategoryListViewModel.setTitleCSSStyle(cssStyle.getTitleCSSStyle());
        // this.featuredCategoryListViewModel.setSearchKey(props.searchKey);
        return (
            <>
           
            
                {
                    this.getWebView(props, state, cssStyle)
                }
            
           
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>

            </>
        );
    }

    getWebView(props: NameTunesComponentProps, state: NameTunesComponentState, cssStyle: NameTunesCSSStyle):JSX.Element
    {
        return(
            <>
                 <div style={cssStyle.getWrapperCSSStyle()}>
                 <div style={cssStyle.getInnerWrapperCSSStyle()}>
                    <div id="nametune-search">
                            <div id="nametune-search-box" >
                                <SearchBoxComponent ref={(item: any) => this.searchComponent = item}  context={props.context}  searchKey={props.searchKey} onSearchBoxButtonClicked={this.onSearchClick} cssStyle={this.searchCSSStyle}/>
                                    
                            </div>
                            <div id="nametune-clear" >
                                < img id="clear-img" onClick={this.clearData}  src={this.getContext().getResources().getImage("close.svg")}/>
                            </div>
                    </div>
                    
               
                   
                     {
                         this.featuredCategoryListViewModel.getListOfDatas().length > 0 &&
                         <div id="nametunesearch-result" style={{}}>
                            {
                                this.getSearchResult(props.context)

                            }
                       </div> 
                     }  
                       {
                         state.isEmpty &&
                       <div id="nametune-search-noresult-card" style={{width:'100%',height:'160x',marginBottom:'50px'}}/>
                     }
                     {state.isDataNotLoaded &&
                        <div id="nametune-search-noresult-card" style={{width:'100%',height:'160x',marginBottom:'50px'}}>
                            <NoResultComponent  context={this.getContext()}/>
                        </div>
                     }
                     {/* {state.isNoSearchResult &&
                       <div style={{width:'100%',height:'100%'}}>
                              <AddNameTunesComponent  isDisabled={false}  context={this.getContext()}  searchKey={props.searchKey} />
                       </div>    
                     } */}
{/*                       
                      {!state.isDataNotLoaded &&
                       <div style={{width:'100%',height:'160x',marginBottom:'50px'}}/>
                     } */}
                 </div>
                  
                   
            </div>
            </>
        );
    }

    getSearchResult(context:BaseContext):JSX.Element
    {
        // (this.listViewModel as ListViewModelImpl<ToneDto>).setTitleCSSStyle(cssStyle.getTitleCSSStyle());
        // this.featuredCategoryListViewModel.setListDatas(this.getListOfTones());
        return (
        <>
        <h2 id="nametune-search-result-for-label" style={(this.getUICSSStyle() as NameTunesCSSStyle).getTitleCSSStyle()}>{context.getResources().getString(Strings.search_results_for)+ (this.getUIProps() as NameTunesComponentProps).searchKey}</h2>
        <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.featuredCategoryListViewModel} context={context}/>
        </>
        );

    }


    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    showPopup(id:string,msg:string,type:AlertType):void
    {
        this.closePopup();
         if(type === AlertType.WARN)
         {
             
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={()=>''} context={this.getUIProps().context}/>);

         }
        
         else 
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

         }
    }
    clearData():void
    {
        this.searchComponent.clearData();

    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    onSearchClick(searchKey:string):void
    {
        if(this.searchComponent.validate())
        {
            searchKey = searchKey.trim();
        (this.getUIComponentHandler() as NameTunesComponentHandler).onDataNotLoaded(false);
        (this.getUIComponentHandler() as NameTunesComponentHandler).onSearchClicked(searchKey);
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunesview.tsx